import type { HandregalAusstattung } from '@/data/handregal-ausstattung'
import type { RegalFach } from './handregal-geometrie'

export function feldVonLinks(fach: RegalFach, ausstattung: HandregalAusstattung): number {
  const gang = ausstattung.gang[fach.etage]
  const start = fach.seite === 'links' ? 2 : gang[gang.length - 1] + 1
  const starts = [start, ...ausstattung.feldStart[fach.etage]]
    .filter(c => fach.seite === 'links' ? c < gang[0] : c >= start)
  return starts.filter(c => c <= fach.spalte).length
}

export function adresse(fach: RegalFach, ausstattung: HandregalAusstattung): string {
  const etage = fach.etage === 'EG' ? 'Erdgeschoss' : 'Obergeschoss'
  const seite = fach.etage === 'EG'
    ? (fach.seite === 'links' ? 'linke Hälfte' : 'rechte Hälfte')
    : (fach.seite === 'links' ? 'links vom Mittelgang' : 'rechts vom Mittelgang')
  return `*${fach.nummer} · ${etage} · Gang ${Math.ceil(fach.band / 2)} · Band ${fach.band} · ${seite} · Feld ${feldVonLinks(fach, ausstattung)} von links · Ebene ${fach.ebene}`
    + (fach.ebene === 1 ? ' (am Boden)' : '') + (fach.spannweite === 2 ? ' · Doppelplatz' : '')
}
